import React from 'react';

const SvgIcFolder = props => (
  <svg
    id="ic_folder_svg__folder"
    width={props.size || 49.777}
    height={props.size || 49.777}
    viewBox="0 0 49.777 49.777"
    xmlSpace="preserve"
    fill="#104eb2"
    {...props}
  >
    <defs></defs>
    <path
      id="ic_folder_svg__Path_383"
      d="M47.695 22.4H44.8v-5.2a2.27 2.27 0 00-2.267-2.267h-2.711v-2l-.411-.411-6.054-6.057L26.891 0H6.637v9.126h-4.37A2.27 2.27 0 000 11.392v36.244a2.118 2.118 0 002.123 2.141h37.138a2.106 2.106 0 002.033-1.5l8.484-23.261v-.147a2.222 2.222 0 00-2.083-2.469zm-5.162-5.807a.608.608 0 01.607.607v5.2h-3.318v-5.808zM27.377 2.833l9.612 9.611h-9.612zM8.3 1.659h17.418V14.1h12.444v8.3h-27.6a2.129 2.129 0 00-.35.029A2.092 2.092 0 008.529 23.9l-.233.64V1.659zm-6.641 9.733a.608.608 0 01.607-.607h4.37v18.281L1.659 42.642zm38.054 36.38a.469.469 0 01-.452.346H2.128a.458.458 0 01-.372-.184.449.449 0 01-.1-.338L6.637 33.93l3.451-9.461.022-.068a.47.47 0 01.452-.346h37.133c.315 0 .4.453.416.679z"
      className="ic_folder_svg__cls-1"
      data-name="Path 383"
    />
    <path
      id="ic_folder_svg__Path_384"
      d="M15.83 16.659h8.3a.83.83 0 000-1.659h-8.3a.83.83 0 000 1.659z"
      className="ic_folder_svg__cls-1"
      data-name="Path 384"
      transform="translate(-2.556 -2.556)"
    />
    <path
      id="ic_folder_svg__Path_385"
      d="M15.83 9.659h8.3a.83.83 0 000-1.659h-8.3a.83.83 0 000 1.659z"
      className="ic_folder_svg__cls-1"
      data-name="Path 385"
      transform="translate(-2.556 -1.363)"
    />
    <path
      id="ic_folder_svg__Path_386"
      d="M15.83 23.659h19.91a.83.83 0 000-1.659H15.83a.83.83 0 000 1.659z"
      className="ic_folder_svg__cls-1"
      data-name="Path 386"
      transform="translate(-2.556 -3.748)"
    />
  </svg>
);

export default SvgIcFolder;
